module.exports = __webpack_public_path__ + "static/fonts/MaterialIcons-Regular.570eb83.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont/MaterialIcons-Regular.woff2
// module id = BESl
// module chunks = 0